import type { BatchStatus } from '@avs/contract';

const STATUS_LABEL: Record<BatchStatus, string> = {
  draft: '草稿',
  processing: '处理中',
  done: '已完成',
  failed: '失败',
};

export function StatusTag({ status }: { status: BatchStatus }) {
  return <span className={'tag s-' + status}>{STATUS_LABEL[status]}</span>;
}

export function LineTag({ children }: { children: React.ReactNode }) {
  return <span className="tag-line">{children}</span>;
}
